import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import GigsFilter from '../pieces/GigsFilter';

class Gigs extends Component {
  componentDidMount(){
    this.props.getEvents();
  }
  render(){
// console.log(this.props);
    return(
      
      <div className="general-content gigs-content">
        <h2 className="content-headline no-margin">Gigs</h2>
        <GigsFilter
          choices={this.props.choices}
          events={this.props.events}
          currEvents={this.props.currEvents}
          currMonth={this.props.currMonth}
          currYear={this.props.currYear}
          getCurrentEvents={this.props.getCurrentEvents}
        />

        <section className="content-block">
          <h3 className="gigs-heading no-margin">{this.props.currMonth} {this.props.currYear}</h3>
          { this.props.currEvents.map((val,idx)=>(
            <div className="gig-item" key={idx}>
              <div className="date">{val.Day}</div>
              <div className="details">
                <div className="gig-heading">{val.location}: {val.time}</div>
                <div className="italic">{val.description}</div>
                <div className="address">{val.address}</div>
                {val.link &&
                  <Link to={val.link} target="_blank">More details</Link>
                }
                
              </div>
            </div>
          ))}
          
          
          
        </section>

        

      </div>
    );
  }
}
export default Gigs;


// WEBPACK FOOTER //
// ./src/modules/pages/Gigs.js